import BaseModelAPI from '../BaseModelAPI';

export default class EmployeeLevelList extends BaseModelAPI {

	static entity = 'employeelevellist'
	static entityName = 'employeelevel';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
